<div class="full-height  full-width layout-column overflow-x-auto-only">
  <div class="flex layout-column bringoz-table ">

    <!-- Header -->
    <div class="tr layout-row layout-align-start-center" id="header">
      <div class="th small flex-25">{{'Default Draft Name' | translate}}</div>
      <div class="th small flex">{{'Routes' | translate}}</div>
      <div class="th small flex">{{'Creation Date' | translate}}</div>
      <div class="th small flex">{{'Last Modification' | translate}}</div>
      <div class="th small flex"></div>
    </div>

    <!-- Table Body with Virtual Scroll -->
    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport [itemSize]="isScrollable ? 140 : 60" class="flex viewport" (scroll)="getNextBatch()">
        <app-planning-default-drafts-table-row
          *cdkVirtualFor="let draft of drafts"
          class="item"
          [draft]="draft"
          (deleteDraft)="onDeleteDraft($event)">
        </app-planning-default-drafts-table-row>
      </cdk-virtual-scroll-viewport>
    </div>

  </div>
</div>
